<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">金额充值</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <form>
                <div class="row">
                  <label class="col-xl-3 col-lg-3 col-form-label">余额</label>
                  <div class="col-lg-9 col-xl-6">
                    <div>{{ currentUserBalance }} 元</div>
                  </div>
                </div>
                <!--begin::Form Group-->
                <div class="form-group row">
                  <label class="col-xl-3 col-lg-3 col-form-label"
                    >充值金额</label
                  >
                  <div class="col-lg-9 col-xl-6">
                    <div class="input-group input-group-lg input-group-solid">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="la la-rmb"></i>
                        </span>
                      </div>
                      <input
                        type="number"
                        class="form-control form-control-lg form-control-solid"
                        ref="price"
                        v-model="form.prices"
                        placeholder="金额"
                      />
                    </div>
                  </div>
                </div>
                <!--begin::Form Group-->
                <div class="form-group row">
                  <label class="col-xl-3 col-lg-3 col-form-label"
                    >支付方式</label
                  >
                  <div class="col-lg-9 col-xl-6">
                    <b-form-group>
                      <b-form-radio-group
                        v-model="selected"
                        buttons
                        button-variant="outline-primary"
                        class="mx-n1"
                        name="radio-btn-outline"
                      >
                        <template v-for="option in buyMessage.pay_channels">
                          <b-form-radio
                            :value="option.type"
                            :key="option.type"
                            :disabled="option.disabled"
                          >
                            <span v-if="option.type === 'balance'"> </span>
                            <span v-else v-html="option.html"></span>
                          </b-form-radio>
                        </template>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>
              </form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">关闭</v-btn>
            <v-btn color="blue darken-1" text @click="UserRecharge">充值</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Qrcode
      v-bind:dialog.sync="qrcodeDialog"
      :orderResultData="orderResultData"
    ></Qrcode>
  </div>
</template>

<script>
import { postInstance } from "@/api/instance";
import Qrcode from "@/view/pages/pay/Qrcode";
import { fetchBuyMessage } from "@/api/message";
import { mapGetters } from "vuex";
export default {
  name: "Recharge",
  components: {
    Qrcode,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      selected: "weixin",
      qrcodeDialog: false,
      orderResultData: {
        order_id: "",
        url: "",
        pay_type: "",
      },
      form: {
        action: "recharge",
        prices: 10,
        pay_type: this.selected,
      },
      buyMessage: {
        pay_channels: [],
        products: [],
        sales: [],
      },
    };
  },
  computed: {
    ...mapGetters(["currentUserBalance"]),
  },
  mounted() {
    fetchBuyMessage().then((res) => {
      this.buyMessage = res.result;
      this.buyMessage.pay_channels.shift();
    });
  },
  methods: {
    UserRecharge() {
      this.form.pay_type = this.selected;
      postInstance("ORDER", this.form).then((res) => {
        this.orderResultData = res.result;
        this.qrcodeDialog = true;
      });
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
};
</script>

<style scoped></style>
